import moment from "moment";
import React from "react";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import '../pages/landingPage/style.css';
import TextInput from "./TextInput";
import Cookies from "universal-cookie";
import getInsegnanti from '../services/getInsegnanti';
import translateString from "../utils/Locales";

let t = translateString;

export default class StudentLessonInfoWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            option: this.option,
            isLoading: true,
        }
    }

    async componentDidMount() {

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.dbPath = cookies.get('db_path', { path: '/' });
        this.insegnanti = await getInsegnanti(username, token);
        this.insegnanti_str = '';
        console.error(this.props.lezione);
        this.insegnanti.forEach((insegnante) => {
            if (insegnante.id == this.props.lezione.id_insegnante || this.props.lezione.altri_insegnanti.split(';').indexOf(insegnante.id) != -1) {
                this.insegnanti_str += insegnante.cognome + ' ' + insegnante.nome + ', ';
            }
        });

        this.insegnanti_str = this.insegnanti_str.slice(0, -2);
        this.setState({ isLoading: false, insegnanti: this.insegnanti_str });
    }

    render () {

        const cookies = new Cookies();

        if (this.state.isLoading) return <div />;
        
        return ( 

        <div key={Math.random()}  style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.setState({ visible: false }); this.props.onClose(); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                
            <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onClose();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>

                <div style={{paddingLeft: '5px'}}>
                <div style={windowTitle}>{t('dettagli_lezione')}</div>
                </div>

                <p style={{ marginLeft: 10, marginTop: 10, fontSize: 16, color: 'darkgrey', fontWeight: 'bold' }}>{t('lezione_di')}: {this.props.lezione.str_materia}</p>
                <p style={{ marginLeft: 10, marginTop: -10, fontSize: 13, color: 'darkgrey', fontWeight: 'bold' }}>{this.state.insegnanti}</p>
                <TextInput readOnly value={moment(this.props.lezione.data, 'yyyy-MM-DD HH:mm').format('DD/MM/yyyy')} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '280px', marginLeft: 10, backgroundColor: 'white', cursor: 'cursor' }} />
                <TextInput readOnly value={t('alle') + ': '+ moment(this.props.lezione.data, 'yyyy-MM-DD HH:mm').format('HH:mm')} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '280px', marginLeft: 10, backgroundColor: 'white', cursor: 'cursor' }} />
                <TextInput readOnly value={this.props.lezione.aula ? t('aula') + ': ' + this.props.lezione.aula : t('aula_n_definita')} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '280px', marginLeft: 10, backgroundColor: 'white', cursor: 'cursor' }} />
                
                { (this.props.lezione.online === '1' && this.props.insegnante === undefined) &&  <div style={{ textAlign: 'center', width: '100%', marginTop: 20, marginBottom: 10 }}><div className="btn btn-primary" style={{ marginTop: 10 }} onClick={() => { cookies.set('currentLezione', this.props.lezione.id, { path: '/' }); window.open(this.props.lezione.join_link, '_blank'); }}>{t('vai_lez_online')}</div></div> }
                { (this.props.insegnante != undefined && this.props.insegnante === true && this.props.lezione.data.includes(moment().format('yyyy-MM-DD'))) && (
                    <div style={{ textAlign: 'center', width: '100%', marginTop: 20, marginBottom: 10 }}>
                        <div className="btn btn-primary" onClick={() => { cookies.set('currentLezione', this.props.lezione.id, { path: '/' }); window.location.href = '/' + this.dbPath + "/#/app/gestionePresenze"; }}>{t('registro_presenze')}</div>
                        { this.props.lezione.online === '1' && <br/> }
                        { (this.props.lezione.online === '1' && this.props.insegnante) && <div className="btn btn-primary" style={{ marginTop: 10 }} onClick={() => { cookies.set('currentLezione', this.props.lezione.id, { path: '/' }); window.open(this.props.lezione.host_link, '_blank'); }}>{t('vai_lez_online')}</div> }
                    </div>
                )}
            </div>
            </div>
        </div>
        )
    }


}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
    marginBottom: 10,
}

const closeBtn = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10, 
    zIndex: 999,
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowY: 'scroll',
    overflowX: 'hidden',
};

const mainClass = {
    paddingBottom: 10, 
    position: 'absolute',
    left: 'calc((100% - 400px)/2',
    top: '200px',
    right: '35%',
    minWidth: '400px',
    width: '400px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
}